// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"styles__subTitle___1gGnh","green":"styles__green___2nQ-F","red":"styles__red___3bYTr","gold":"styles__gold___QwDUB"};